import {Injectable} from '@angular/core';
import {FlashMessagesService} from 'angular2-flash-messages';
import {URL_API} from "../constante";
import {Headers, Http, RequestOptions, Response} from '@angular/http';
import 'rxjs/add/operator/toPromise';
import {HEADERS} from './../constante';
import {Avaliacao} from "./avaliacao";
import {Usuario} from "../usuario/usuario";
import {Trabalho} from "../trabalho/trabalho";
import {Utils} from '../shared/utils';

@Injectable()
export class AvaliacaoService {
    options: RequestOptions;
    headers:any;

    private url_api = URL_API + '/avaliacao';

    save(avaliacao: Avaliacao): Promise<Response> {
        return this.http
            .post(this.url_api, JSON.stringify(avaliacao), {headers: HEADERS})
            .toPromise()
            .then(response => this.utils.handle(response))
            .catch((error) => this.utils.handleError(error));
    }


    correction(dados): Promise<Response> {
        return this.http
            .post(this.url_api+"/corrigir", JSON.stringify(dados), {headers: HEADERS})
            .toPromise()
            .then(response => this.utils.handle(response))
            .catch((error) => this.utils.handleError(error));
    }

    enviarEmail(data: Trabalho, acao: string): Promise<Response> {
        return this.http
            .post(this.url_api + acao, JSON.stringify(data), {headers: HEADERS})
            .toPromise()
            .then(response => this.utils.handle(response))
            .catch((error) => this.utils.handleError(error));
    }

    getAvaliacao(trabId: number, avalId: number): Promise<Avaliacao> {
        let url: string = this.url_api + '/' + trabId + '/' + avalId;
        return this.http.get(url)
            .toPromise()
            .then(response => response.json() as Avaliacao)
            .catch((error) => this.utils.handleError(error));
    }

    setParecerista(dados): Promise<Response> {
        let url: string = URL_API +'/trabalho/storeParecerista';
        return this.http
            .post(url, JSON.stringify(dados), {headers: HEADERS})
            .toPromise()
            .then(response => this.utils.handle(response))
            .catch((error) => this.utils.handleError(error));
    }

    setGrupo(dados): Promise<Response> {
        let url: string = URL_API +'/trabalho/storegrupo';
        return this.http
            .post(url, JSON.stringify(dados), {headers: HEADERS})
            .toPromise()
            .then(response => this.utils.handle(response))
            .catch((error) => this.utils.handleError(error));
    }

    getAvaliacaos(): Promise<Avaliacao[]> {
        let url: string = this.url_api;
        return this.http.get(url)
            .toPromise()
            .then(response => response.json() as Avaliacao[])
            .catch((error) => this.utils.handleError(error));
    }

    getparecerista(): Promise<Usuario[]> {
        let url: string = URL_API +'/usuario/perfilsys/2';
        return this.http.get(url)
            .toPromise()
            .then(response => response.json() as Usuario[])
            .catch((error) => this.utils.handleError(error));
    }

    constructor(private http: Http,
                private flashMessagesService: FlashMessagesService,
				private utils: Utils) {
        this.headers = HEADERS;
        this.options = new RequestOptions({ headers: this.headers });
    }
	
	exportar(trabalhos: Trabalho[]): Promise<Response> {
        return this.http
            .post(this.url_api + '/exportar', JSON.stringify(trabalhos), {headers: HEADERS})
            .toPromise()
            .then(response => {
				this.utils.handle(response);
				window.open(URL_API + response.json().arquivo);
			})
            .catch((error) => this.utils.handleError(error));
			
    }
}



// WEBPACK FOOTER //
// ./src/app/avaliacao/avaliacao.service.ts